import React, { useState } from "react";
import { Tabs, TabList, Tab } from "@tvg/design-system";
import { DynamicSelectorWrapper, SelectionsWrapper } from "./styled-components";

export interface DynamicSelectorListItem {
  value: string;
  title: string;
  description: string;
}

interface Props {
  itemsList: DynamicSelectorListItem[];
  onTabChange: CallableFunction;
}

const DynamicSelector = (props: Props) => {
  const [selectedTab, setSelectedTab] = useState("");
  return (
    <DynamicSelectorWrapper>
      <SelectionsWrapper>
        <Tabs
          isStretched
          onChange={(val) => {
            setSelectedTab(val);
            props.onTabChange(val);
          }}
          selectedValue={selectedTab || props.itemsList[0].value}
          qaLabel="dynamic-selector"
        >
          <TabList qaLabel="tabList" isStretched>
            {props.itemsList.map((item) => (
              <Tab
                key={item.title}
                value={item.value}
                title={item.title}
                description={item.description}
                noBorder
              />
            ))}
          </TabList>
          <></>
        </Tabs>
      </SelectionsWrapper>
    </DynamicSelectorWrapper>
  );
};

export default DynamicSelector;
